/* Renegade community map. No external scripts or tracking. */
if (!customElements.get('renegade-community-map')) {
  customElements.define('renegade-community-map', class extends HTMLElement {
    connectedCallback() {
      // Custom elements can connect before their child markup has been parsed.
      const initialize = () => {
        if (!this.isConnected || !this.querySelector('.rb-map__canvas') || !this.querySelector('[data-community-card]')) return false;
        this.childObserver?.disconnect();
        this.initializeMap();
        return true;
      };
      if (!initialize()) {
        this.childObserver = new MutationObserver(() => initialize());
        this.childObserver.observe(this, { childList:true, subtree:true });
      }
    }
    initializeMap() {
      this.abort?.abort();
      this.layoutObserver?.disconnect();
      this.abort = new AbortController();
      const header = document.querySelector('.section-header');
      if (header) {
        this.headerObserver?.disconnect();
        this.headerObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--rb-header-height', `${header.getBoundingClientRect().height}px`);
        });
        this.headerObserver.observe(header);
      }
      const options = { signal: this.abort.signal };
      this.triggers = [...this.querySelectorAll('[data-community-trigger]')];
      this.cards = [...this.querySelectorAll('[data-community-card]')];
      this.active = null;
      this.classList.add('is-enhanced');
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.lastTrigger = trigger;
          this.show(this.active === trigger.dataset.communityTrigger ? null : trigger.dataset.communityTrigger);
        }, options);
      });
      this.querySelectorAll('[data-community-close]').forEach(button => {
        button.addEventListener('click', () => this.close(), options);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.active) {
          event.preventDefault();
          this.close();
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        if (this.cards.some(card => card.dataset.communityCard === id)) this.show(id);
      }, options);
      this.show(null);
      this.layoutObserver = new ResizeObserver(() => this.positionCard());
      this.layoutObserver.observe(this.querySelector('.rb-map__canvas'));
      this.cards.forEach(card => this.layoutObserver.observe(card));
      window.addEventListener('resize', () => this.positionCard(), options);
      document.addEventListener('click', event => {
        if (this.active && !this.contains(event.target)) this.show(null);
      }, options);
    }
    positionCard() {
      if (!this.active) return;
      const layer = this.querySelector('.rb-map__cards');
      if (!window.matchMedia('(min-width: 990px)').matches) {
        layer.style.removeProperty('left');
        layer.style.removeProperty('top');
        return;
      }
      const card = this.cards.find(item => item.dataset.communityCard === this.active);
      const pin = this.querySelector(`.rb-map__pin[data-community-trigger="${this.active}"]`);
      const canvas = this.querySelector('.rb-map__canvas');
      if (!card || !pin || !canvas) return;
      const bounds = canvas.getBoundingClientRect();
      const point = pin.getBoundingClientRect();
      const x = point.left + point.width / 2 - bounds.left;
      const y = point.top + point.height / 2 - bounds.top;
      const width = layer.offsetWidth;
      const height = card.offsetHeight;
      const gap = 32;
      const left = x + gap + width <= bounds.width - 16 ? x + gap : x - gap - width;
      const header = document.querySelector('.section-header');
      const safeTop = Math.max(16, (header?.getBoundingClientRect().bottom || 0) - bounds.top + 12);
      const topLimit = Math.max(16, bounds.height - height - 16);
      layer.style.left = `${Math.max(16, Math.min(left, bounds.width - width - 16))}px`;
      layer.style.top = `${Math.max(Math.min(safeTop, topLimit), Math.min(y - height / 2, topLimit))}px`;
    }
    show(id) {
      this.active = id;
      this.cards.forEach(card => { card.hidden = card.dataset.communityCard !== id; });
      this.triggers.forEach(trigger => {
        const selected = trigger.dataset.communityTrigger === id;
        trigger.setAttribute('aria-expanded', String(selected));
        trigger.classList.toggle('is-active', selected);
      });
      this.positionCard();
    }
    close() {
      const returnFocus = this.lastTrigger || this.triggers.find(trigger => trigger.dataset.communityTrigger === this.active);
      this.show(null);
      returnFocus?.focus({ preventScroll: true });
    }
    disconnectedCallback() { this.abort?.abort(); this.headerObserver?.disconnect(); this.layoutObserver?.disconnect(); this.childObserver?.disconnect(); }
  });
}
